/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useContext, useEffect, useState } from "react"
import { Button, Col, Container, Form, Row } from "react-bootstrap"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import { showInfoToast } from "../../../components/CustomToast"

import { TApiResponse } from "../../../service/TApiResponse"
import KadoTyoseiService from "../../../service/driverpayroll/kadoTyosei/kadoTyoseiService"
import {
  TKadoTyoseiListGetRes,
  TKadoTyoseiPutReq,
} from "../../../service/driverpayroll/kadoTyosei/TKadoTyosei"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import _ from "lodash"
import CONSTANT from "../../../constant"
import { FunctionContext } from "../../../components/Context"

/**
 * 稼働調整 登録モーダル
 * ※ EXCEL貼り付け用Modal
 * @param {*} props
 * @return {*} reactNode
 */
const KadoTyoseiRegisterModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    年月?: string
    登録更新: "登録" | "更新"
  }
> = (props) => {
  //#region [state]
  // 検索用
  const pageSearch = useContext(FunctionContext)

  //アラート制御

  // state
  const [年月, set年月] = useState<string | null | undefined>(
    props.年月 ?? null
  )

  // Grid
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)
  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後
  const [isItemComplete, setIsItemComplete] = useState(false)

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>) =>
    new wjcCore.CollectionView(data, {})

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([]),
  })
  // 削除アイテムリスト
  const [gridDataDeleteList, setGridDataDeleteList] =
    useState<TKadoTyoseiListGetRes[]>()

  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
    grid.refresh()
  }

  const search = async () => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    setIsSubmitButton(false)

    // 削除用リストを初期化
    let clearList: TKadoTyoseiListGetRes[] = []
    setGridDataDeleteList(clearList)

    try {
      const res = await new KadoTyoseiService().getList({
        年月: 年月 ?? "",
      })

      // 削除用リストに取得データをコピーする
      let copyListKadoTyosei: TKadoTyoseiListGetRes[] = []
      res.data.forEach((d) => {
        // DeepCopy
        copyListKadoTyosei.push(_.cloneDeep(d))
      })
      setGridDataDeleteList(copyListKadoTyosei)

      // Grid表示用
      let gridItem: TKadoTyoseiListGetRes[] = []
      res.data.forEach((d) => {
        // DeepCopy
        gridItem.push(_.cloneDeep(d))
      })
      const newData = createCollectionView([...gridItem])
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSubmitButton(true)
      setIsSpinnerShow(false)
      flexGrid?.refresh()
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  //TODO:PUTのみAPIで処理
  const submit = async () => {
    try {
      // DB更新用リスト
      let dataList: Array<TKadoTyoseiPutReq> = []

      gridData.data.items.forEach((d) => {
        // すべて新規登録する為、PKと更新日時はundefined
        let data: TKadoTyoseiPutReq = {
          乗務員稼働調整貼り付けID: undefined,
          社員ID: d.社員ID,
          社員コード: d.社員コード,
          年月: 年月!,
          稼働調整額: d.稼働調整額,
          削除フラグ: 0,
          更新日時: undefined,
        }
        dataList.push(data)
      })

      // 削除リストを更新用リストへ追加
      gridDataDeleteList?.forEach((d) => {
        // 削除フラグを1にして追加
        let data: TKadoTyoseiPutReq = {
          乗務員稼働調整貼り付けID: d.乗務員稼働調整貼り付けID,
          社員ID: d.社員ID,
          年月: d.年月,
          社員コード: d.社員コード,
          稼働調整額: d.稼働調整額,
          削除フラグ: 1,
          更新日時: d.更新日時,
        }
        dataList.push(data)
      })

      const service = new KadoTyoseiService()

      let res: TApiResponse<boolean>

      res = await service.put(dataList)

      //   disPatch(setAlerts(res))
      setAlertSource(res)
      if (res) {
        props.setIsShow(false)
        showInfoToast(`乗務員 稼働調整(貼り付け)の"更新"が完了しました。`)
        // 遷移元画面の再検索
        pageSearch()
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  useEffect(() => {
    setAlertSource(undefined)

    if (props.isShow) {
      set年月(props.年月 ?? "")
      setIsItemComplete(true)
    } else {
      // 非表示時中身を空にして閉じる
      set年月("")
      const newData = {
        data: createCollectionView([]),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setAlertSource(undefined)
      setGridData(newData)
      setIsItemComplete(false)
      setIsSpinnerShow(false)
    }
  }, [props.isShow, props.年月])

  // 準備完了後、検索
  useEffect(() => {
    if (!isItemComplete) return
    search()
  }, [isItemComplete])
  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "乗務員 稼働調整貼り付け"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <>
          <Button
            type="submit"
            variant={isSubmitButton ? "waiting" : "secondary"}
            disabled={!isSubmitButton}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              beforeSubmit()
            }}>
            EXCEL稼働調整貼付更新
          </Button>
        </>
      }>
      <Spinner inModal searching={isSpinnerShow}></Spinner>

      <Form>
        <Container fluid className="register-form">
          {/* アラート表示 */}
          <LocalAlertComponent alertSource={AlertSource} />
          <Row>
            <Col>
              <div className="search-condition-table">
                <div className="search-condition-row">
                  <div className="w-10rem">
                    <MonthInput
                      id="年月"
                      value={年月}
                      setValue={set年月}
                      isRequired={true}
                      isReadOnly
                      placeholder="年月"
                    />
                  </div>

                  {/* <Button
                    type="submit"
                    disabled={isSearching}
                    onClick={(e) => {
                      e.preventDefault()
                      search()
                    }}>
                    検索
                  </Button> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Form>

      <Row>
        <Col>
          {/* 結果グリッド */}
          <div className="d-flex">
            <div className="overflow-auto">
              <wjrGrid.FlexGrid
                {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                keyActionTab={wjcGrid.KeyAction.None}
                selectionMode={wjcGrid.SelectionMode.Cell}
                initialized={gridInitialized}
                style={{ height: "30rem" }}>
                <wjrGridFilter.FlexGridFilter />
                <wjrGrid.FlexGridColumn
                  width={100}
                  header="社員番号"
                  binding="社員コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={150}
                  header="氏名"
                  binding="社員氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={150}
                  format="G"
                  header="稼働調整額"
                  binding="稼働調整額"></wjrGrid.FlexGridColumn>
              </wjrGrid.FlexGrid>
            </div>
          </div>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default KadoTyoseiRegisterModal
